// extracted by mini-css-extract-plugin
module.exports = {"button":"new-button-module--button--1jTb5"};